module.exports = __webpack_public_path__ + "static/img/betTable.74dd9ca.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/dailyFreeCash/betTable.webp
// module id = aQ0w
// module chunks = 0